export {default as vuex} from './index'